<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Environment Info</h1>

@if (isLoading()) {
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
}
@else {

  @if (error()) {
    <app-error-message
      [error]="error()"
      [heading]="'Could not load environments'"
      [showRetry]="true"
      (retry)="reload()"
    ></app-error-message>
  }
  @else {
    @let environment = environmentUiService.environment$();
    @if (!environment) {
      <p>No environment found for this ID {{ currentEnvId }}.</p>
    }
    @else {
      <div class="tw-flex tw-flex-row tw-w-full tw-items-start tw-justify-start tw-gap-8">
        <div class="tw-flex tw-flex-col tw-gap-4">
          <!-- Env info -->
          <div class="tw-flex tw-flex-col tw-gap-2">
            <img src="assets/imgs/aveva-erm-logo-64x64.png" class="env-info-icon tw-w-16" />
            <p><strong>AVEVA ERM v{{environment.version}} {{environment.name}}</strong></p>
            <p><strong>Id:</strong> {{environment.environmentId}} <lib-env-labels [env]="environment"></lib-env-labels></p>
            <p><strong>Description:</strong> {{environment.description}}</p>
            <p><strong>Region:</strong> {{environment.region?.displayName}}</p>
            <p><strong>Status:</strong>&nbsp;<lib-env-status [env]="environment"></lib-env-status></p>
          </div>
          
          @if (environment.statusMessage) {
            <p><em>{{environment.statusMessage}}</em></p>
          }
    
          <div class="tw-flex tw-flex-col tw-gap-4 tw-w-96">
            <!-- Services panel -->
            <app-environment-services></app-environment-services>
    
            <!-- Environment panel -->
            <app-environment-launch></app-environment-launch>
    
            <!-- Support button -->
            @if (environment.canBeSupportedByUser === true) {
            <a
              mat-raised-button
              (click)="startSupportButtonClick()"
              title="In support mode, you can work with tooling that enables troubleshooting of a given ERM environment.">
              Start Support
            </a>
            }
          </div>
        </div>

        <!-- Scale progress only for non-AWS Stage Prod environments -->
        @if (isAwsStageProd === false && environmentUiService.scaleProgress$()) {
          <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-4 tw-bg-gray-50 tw-border tw-border-gray-200 tw-rounded-lg tw-p-4">
              <div class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-w-full">
                <h2 class="tw-text-lg tw-font-bold">Scale Progress</h2>
                <button type="button" (click)="environmentUiService.scaleProgress$.set(null)" class="tw-h-10 tw-px-4 tw-rounded-md tw-text-sm tw-shadow-sm tw-transition tw-bg-indigo-600 hover:tw-bg-indigo-700 tw-text-white">
                  Close
                </button>

              </div>
              <app-scale-progress-events class="tw-w-full" [progress]="environmentUiService.scaleProgress$()"></app-scale-progress-events>
          </div>
        }
      </div>

    } 
  }

}
